export default __webpack_public_path__ + "static/media/necklace.01df69f9.png";